<template>
  <div class="logcard">
    <b-card align="left" border-variant="dark">
      <b-card-title>
        <b-container fluid>
          <b-row align-v="top">
            <b-col class="logtitle" align-self="start" cols="7" sm="10" @click="viewLog(log.objectID)">
              {{ trimmedLog }}
            </b-col>
            <b-col class="favorite" cols="5" sm="2">
              <!-- <font-awesome-icon v-if="log.public === false" class="public-icon" :icon="['fas','lock']"/> -->
              <!-- <font-awesome-icon v-if="log.public === true" class="public-icon" :icon="['fas','lock-open']"/> -->
              <span class="h5" :style="{ color: '#f06292'}" v-b-tooltip.hover :title="log.favorite">{{ favoriteNum }}</span>
              <b-button v-if="user" @click="setFavorite(log.your_favorite)" variant="link">
                <font-awesome-icon v-if="log.your_favorite === true" :icon="['fas','heart']" size="s" :style="{ color: '#f06292'}" />
                <font-awesome-icon v-if="log.your_favorite === false" :icon="['far','heart']" size="s" :style="{ color: '#f06292'}" />
              </b-button>
              <b-button v-else variant="link" v-b-tooltip.hover title="Please login.">
                <font-awesome-icon v-if="log.your_favorite" :icon="['fas','heart']" size="s" :style="{ color: '#f06292'}" />
                <font-awesome-icon v-else :icon="['far','heart']" size="s" :style="{ color: '#f06292'}" />
              </b-button>
              <b-badge v-if="log.public === true" class="public-badge" variant="info">public</b-badge>
              <b-badge v-if="log.public === false" class="public-badge" variant="danger">private</b-badge>
              <b-button @click="copyLink" variant="link" v-b-tooltip.hover title="Copy link">
                <font-awesome-icon class="public-badge" :icon="['fas', 'link']" size="s" :style="{ color: '#757575'}" />
              </b-button>
              <b-button v-if="checkMine === true" @click="$bvModal.show('edit-'+log.objectID)" variant="link" v-b-tooltip.hover title="Edit log.">
                <font-awesome-icon class="public-badge" :icon="['fas', 'edit']" size="s" :style="{ color: '#757575'}" />
              </b-button>
              <b-button v-if="checkMine === true" @click="$bvModal.show(log.objectID)" variant="link" v-b-tooltip.hover title="Delete log.">
                <font-awesome-icon class="public-badge" :icon="['fas', 'trash']" size="s" :style="{ color: '#757575'}" />
              </b-button>
            </b-col>
          </b-row>
        </b-container>
      </b-card-title>
      <div class="time" v-b-tooltip.hover.top :title="logTimeTooltipString">
        {{ logTimeString }}
      </div>
      <div>
        <b-badge class="label" variant="dark">{{ log.target }}</b-badge>
        <b-badge class="label" variant="dark">{{ log.version}}</b-badge>
      </div>
      <b-container fluid>
        <b-row align-v="top">
          <b-col v-b-tooltip.hover title="A CAUSE of this log" cols="1" class="colicon">
            <font-awesome-icon :icon="['far','question-circle']" size="s" />
          </b-col>
          <b-col align-self="end" cols="11">
            <b-card-text>{{ trimmedCause }}</b-card-text>
          </b-col>
        </b-row>
        <b-row align-v="top">
          <b-col v-b-tooltip.hover title="An ACTION to this log" cols="1" class="colicon">
            <font-awesome-icon :icon="['far','hand-point-right']" size="s" />
          </b-col>
          <b-col align-self="end" cols="11">
            <b-card-text>{{ trimmedAction }}</b-card-text>
          </b-col>
        </b-row>
      </b-container>
    </b-card>
    <b-modal
      :id="log.objectID"
      title="Confirmation!"
      ok-title="Delete"
      @ok="deleteLog"
    >
      <h6>Do you really want to delete this log?</h6>
      <h4>{{ log.log }}</h4>
    </b-modal>
    <b-modal
      :id="'edit-'+log.objectID"
      title="Edit log"
      size="xl"
      :hide-footer="true"
    >
      <Edit
        :objectID.sync="log.objectID"
        :log.sync="log.log"
        :target.sync="log.target"
        :version.sync="log.version"
        :cause.sync="log.cause"
        :action.sync="log.action"
        :uid.sync="log.uid"
        :created_at.sync="log.created_at"
        :public.sync="log.public"></Edit>
    </b-modal>
    <b-modal
      :id="'view-'+log.objectID"
      title="View detail log"
      size="xl"
      :hide-footer="true"
    >
      <DetailView :log="log"></DetailView>
    </b-modal>
  </div>
</template>

<script>
import firebase from 'firebase'
import axios from 'axios'
import Edit from './Edit.vue'
import DetailView from './DetailView.vue'
import moment from 'moment'
const apiUrl = 'https://logcrow.appspot.com/'
// const apiUrl = 'http://192.168.212.101:9999/'
// const apiUrl = 'http://localhost:9999/'
export default {
  name: 'LogCard',
  props: ['log'],
  components: {
    Edit,
    DetailView
  },
  methods: {
    makeToast(variant = null, message) {
      this.$root.$bvToast.toast(message, {
        title: `${variant || 'message'}`,
        variant: variant,
        solid: true
      })
    },
    setFavorite(yourFavorite) {
      let currentUser = firebase.auth().currentUser
      if (currentUser) {
        // ログイン状態の時のみ実行
        let postParam = {objectID: this.log.objectID}
        currentUser.getIdToken(true).then(async (idToken) => {
          if (yourFavorite) {
            this.log.your_favorite = false
            this.log.favorite -= 1
            let res = await axios.delete(apiUrl + 'favorite', {data: postParam,
              headers: {'Authorization': `Bearer ${idToken}`}
            })
            if (!res.data) {
              this.makeToast('danger', "Failed to delete favorite...")
            }
          } else {
            this.log.your_favorite = true
            this.log.favorite += 1
            let res = await axios.post(apiUrl + 'favorite', postParam, {
              headers: {'Authorization': `Bearer ${idToken}`}
            })
            if (!res.data) {
              this.makeToast('danger', "Failed to set favorite...")
            }
          }
        }).catch(() => {
          this.makeToast('danger', "Failed...")
        })
      }
    },
    deleteLog() {
      let currentUser = firebase.auth().currentUser
      if (currentUser) {
        // ログイン状態の時のみ実行
        let postParam = {objectID: this.log.objectID}
        currentUser.getIdToken(true).then(async (idToken) => {
          let res = await axios.delete(apiUrl + 'log', {data: postParam,
            headers: {'Authorization': `Bearer ${idToken}`}
          })
          if (res.data) {
            this.makeToast('success', "Completed to delete log.")
            this.$router.push('/')
          } else {
            this.makeToast('danger', "Failed to delete log...")
          }
        }).catch(() => {
          this.makeToast('danger', "Failed...")
        })
      }

    },
    viewLog(objectID) {
      if( this.$route.path === "/" ) {
        this.$router.push('/_log/' + objectID)
      } else {
        this.$bvModal.show('view-'+ objectID)
      }
    },
    copyLink() {
      let copyText = 'https://logcrow.firebaseapp.com/log/' + this.log.objectID
      document.addEventListener('copy', (e) => {
        e.preventDefault();
        e.clipboardData.setData('text/plain', copyText)
      }, {once:true})
      document.execCommand('copy')
      /*
      let tmpElement = document.createElement('input')
      tmpElement.classList.add('hidden')
      tmpElement.value = copyText
      document.body.appendChild(tmpElement)
      tmpElement.select()
      document.execCommand('copy')
      */
      this.makeToast('info', "Copied!")
    }
  },
  computed: {
    trimmedLog() {
      if( this.log.log.length > 150 ) {
        return this.log.log.substr(0, 147) + '...'
      } else {
        return this.log.log
      }
    },
    trimmedCause() {
      if( this.log.cause.length > 150 ) {
        return this.log.cause.substr(0, 147) + '...'
      } else {
        return this.log.cause
      }
    },
    trimmedAction() {
      if( this.log.action.length > 150 ) {
        return this.log.action.substr(0, 147) + '...'
      } else {
        return this.log.action
      }

    },
    logTimeString() {
      let created_time = moment(this.log.created_at)
      let updated_time = moment(this.log.updated_at)
      if(created_time.isBefore(updated_time)) {
        return '(updated)' + updated_time.fromNow()
      } else {
        return created_time.fromNow()
      }
    },
    logTimeTooltipString() {
      let created_time = moment(this.log.created_at)
      let updated_time = moment(this.log.updated_at)
      if(created_time.isBefore(updated_time)) {
        return updated_time.format("YYYY/MM/DD HH:mm:ss")
      } else {
        return created_time.format("YYYY/MM/DD HH:mm:ss")
      }
    },
    checkMine() {
      if(this.user && this.user.uid === this.log.uid) {
        return true
      } else {
        return false
      }
    },
    favoriteNum() {
      if(this.log.favorite > 100) {
        return "99+"
      } else {
        return this.log.favorite
      }
    },
    user(){
      return this.$store.getters.user
    }
  },
}
</script>

<style>

.logcard {
  padding: 1rem
}
.logtitle {
  cursor: pointer
}
.label {
  margin-left: 1px
}
.favorite {
  text-align: right
}
.colicon {
  text-align: right
}
.time {
  display: inline-block;
  min-width: 150px
}
</style>
